import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {PricingMiscItem} from './misc-item/pricing-misc-item';

@JsonObject('model.PricingCategory')
export class PricingCategory extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(String, 'categoryType')
  categoryType?: string

  @JsonProperty(String, 'type')
  type?: string

  @JsonProperty(Boolean, 'enabled')
  enabled?: boolean

  @JsonProperty(Boolean, 'calcQty')
  calcQty?: boolean

  @JsonProperty(Boolean, 'calcLinFeet')
  calcLinFeet?: boolean

  @JsonProperty(Boolean, 'calcInstall')
  calcInstall?: boolean

  @JsonProperty(Boolean, 'calcFacesSQFT')
  calcFacesSQFT?: boolean

  @JsonProperty(Boolean, 'calcDelivery')
  calcDelivery?: boolean

  @JsonProperty(Number, 'defaultWidth')
  defaultWidth?: number

  @JsonProperty(Number, 'defaultHeight')
  defaultHeight?: number

  @JsonProperty(Number, 'defaultDepth')
  defaultDepth?: number

  @JsonProperty(Number, 'defaultLinesQty')
  defaultLinesQty?: number

  @JsonProperty(Number, 'defaultQty')
  defaultQty?: number

  @JsonProperty([PricingMiscItem], 'miscList')
  miscList?: PricingMiscItem[]

  @JsonProperty(Boolean, 'isBox')
  isBox?: boolean

  @JsonProperty(Number, 'boxesMultiplier')
  boxesMultiplier?: number
}

